import React, { Component } from 'react';
import ParticipantEmail from './ParticipantEmail';
import EditParticipantButton from './EditParticipantButton';
import Grid from 'material-ui/Grid';
import AuthService from '../AuthService';
import axios from 'axios';

class ParticipantEmailWrapper extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.state = {
      isEditing: false,
      email: this.props.participant.email,
      duplicateEmail: false,
      isSendersEmail: false,
      emailHasChanged: false
    };
    this.handleIsEditing = this.handleIsEditing.bind(this);
    this.saveEmail = this.saveEmail.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.hasGeneratedEmail = this.hasGeneratedEmail.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.onCancelEditEmail = this.onCancelEditEmail.bind(this);
    this.hasDupes = this.hasDupes.bind(this);
    this.isSendersEmail = this.isSendersEmail.bind(this);
  }

  handleIsEditing() {
    this.setState({ isEditing: true });
    this.setState({ isSendersEmail: false });
    this.setState({ duplicateEmail: false });
  }

  handleEmailChange(event) {
    const target = event.target;
    const value = target.value.toLowerCase();
    this.setState({ email: value });
    this.setState({ isSendersEmail: false });
    this.setState({ duplicateEmail: false });
    this.setState({ emailHasChanged: true });
  }

  hasDupes() {
    for (let i = 0; i < this.props.document.participants.length; i++) {
      let participantEmail = this.props.document.participants[i].email;
      if (participantEmail === this.state.email && this.state.emailHasChanged) {
        this.setState({ duplicateEmail: true });
        return true;
      }
    }
  }

  isSendersEmail() {
    const user = this.Auth.getUser();
    if (this.state.email === user.email) {
      this.setState({ isSendersEmail: true });
      return true;
    }
  }

  saveEmail() {
    const participantIndex = 0;
    const emailUpdate = {
      email: this.state.email,
      participantIndex: participantIndex
    };
    if (!this.state.emailHasChanged) {
      this.setState({ isEditing: false });
      return;
    }
    if (this.isSendersEmail()) {
      return;
    }
    if (this.hasDupes()) {
      return;
    }
    if (
      this.state.email &&
      !this.validateEmail() &&
      !this.hasDupes() &&
      !this.isSendersEmail()
    ) {
      console.log('saving');
      return axios(
        `${process.env.REACT_APP_API_URL}/documents/kiosk/email/` +
          this.props.document.id,
        {
          method: 'POST',
          mode: 'cors',
          data: emailUpdate
        }
      )
        .then(response => {
          if (response.status === 200) {
            console.log('successful ajax call', response);
            this.props.updateDocuments();
            this.setState({ isEditing: false });
            this.setState({ isSendersEmail: false });
            this.setState({ duplicateEmail: false });
            this.setState({ emailHasChanged: false });
          } else {
            console.log('response', response);
          }
          return response.data;
        })
        .catch(err => {
          console.log('err', err);
        });
    } else {
      console.log('err');
      this.validateEmail();
    }
  }

  validateEmail() {
    var isValidEmail = this.state.email.match(
      /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
    );
    if (this.state.isEditing && this.state.email && isValidEmail) {
      return false;
    } else if (this.state.isEditing && this.state.email) {
      return true;
    }
  }

  UNSAFE_componentWillMount() {
    this.hasGeneratedEmail();
  }

  hasGeneratedEmail() {
    if (this.state.email.indexOf('@myinsuresign.com') > -1) {
      return this.setState({ email: '' });
    } else {
      return this.state.email;
    }
  }

  onCancelEditEmail() {
    this.setState({ isEditing: false });
    this.setState({ email: this.props.participant.email });
    this.setState({ emailHasChanged: false });
  }

  render() {
    return (
      <div>
        <Grid container spacing={24}>
          <Grid item xs={10}>
            <ParticipantEmail
              handleEmailChange={this.handleEmailChange}
              email={this.state.email}
              isEditing={this.state.isEditing}
              validateEmail={this.validateEmail}
              hasGeneratedEmail={this.hasGeneratedEmail}
              duplicateEmail={this.state.duplicateEmail}
              isSendersEmail={this.state.isSendersEmail}
              emailHasChanged={this.state.emailHasChanged}
            />
          </Grid>
          <Grid item xs={2}>
            <EditParticipantButton
              participant={this.props.document.nextParticipant}
              isEditing={this.state.isEditing}
              handleIsEditing={this.handleIsEditing}
              isBeingSaved={this.saveEmail}
              validateEmail={this.validateEmail}
              onCancelEditEmail={this.onCancelEditEmail}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default ParticipantEmailWrapper;



// WEBPACK FOOTER //
// ./src/components/ParticipantEmailWrapper.js